import React, { Component, Fragment } from "react"
import leftArrowImage from "../../assets/images/left-arrow.png"
import {
    CostingServices
} from "../../services"

//components
import Loading from "../../components/Common/Loading"

class CostingComparison extends Component {
    state = {
        costings: [],
        isLoading: false,
        goBack: -1
    }

    componentWillMount() {
        const urlParams = new URLSearchParams(this.props.location.search)
        let ids = urlParams.get("_id").split(',')
        this.props.history.replace('/CostingComparison',
            this.props.location.search
        )
        this.setState({
            ids
        });
        //     if(!ids){
        //         let { ids } = this.props.location.state
        //     CostingServices.costingCompare(ids).then((res) => {
        //         if (res.status === 200) {
        //             this.setState({ costings: res.text.data, isLoading: false })
        //         }
        //     }).catch((err) => {
        //         this.props.getalertMessage("error", err.message)
        //     })
        //     }

    }

    componentDidMount() {

        let { location: { search } } = this.props
        const urlParams = new URLSearchParams(this.props.location.search)
        let ids = urlParams.get("_id").split(',')
        // ids.map(x=>x)
        ids.map(x => x)
        CostingServices.costingCompare(ids).then((res) => {
            if (res.status == 200) {
                this.setState({ costings: res.text.data, isLoading: false })
            }
        }).catch((err) => {
            this.props.getalertMessage("error", err.message)
        })

    }

    printCosting = () => {
        this.setState({ isLoading: true })
        var divToPrint = document.getElementById("costingTableCompare");
        let mydiv = document.getElementById("h6");
        mydiv.innerHTML += "Costing Comparison";
        var divToPrint = document.getElementById("costingTableCompare");
        var newWin = window.open("", "mywindow");
        newWin.document.body.innerHTML = `<html><head><title></title><style>h5{text-align:center}table,th,td{border: 1px solid black !important;text-align:center}</style></head><body>${divToPrint.outerHTML}</body>`
        newWin.focus();
        newWin.print();
        mydiv.innerHTML = null
        this.setState({ isLoading: false })
        newWin.close();
    };

    render() {
        let list = this.state.costings
        return (
            <Fragment>
                {this.state.isLoading && <Loading />}
                <div className="right-section comparing-table mt-3" style={{ height: "auto!important", paddingBottom: "10px" }}>
                    <div class="col-md-12 px-0 py-2 position-top-stick">
                        <div className="col-md-4 nopadding text-left">
                            <span
                                className="p-2 cursor-hover"
                                onClick={() => {
                                    const { route } = { ...this.props.history };
                                    route !== undefined
                                        ? this.props.history.push(`/${route}`, {
                                            [`${route.toLowerCase()}`]: {
                                                ...this.props.history.location.state[
                                                `${route.toLowerCase()}`
                                                ]
                                            }
                                        })
                                        :
                                        this.props.history.goBack();
                                    // this.printFabric()
                                }}
                            >
                                <img width={"20px"} src={leftArrowImage} />
                            </span>
                        </div>
                        <div className="col-md-4 nopadding text-center">
                            <h6>{"Costing Comparison"}</h6>
                        </div>
                        <div className="col-md-4 no-padding">
                            <button
                                type="button"
                                className="primary pull-right px-2 py-1 mr-3"
                                onClick={() => this.printCosting()}
                            >
                                <i className="fa fa-print font-size" />
                            </button>
                        </div>

                    </div>
                    <div id="costingTableCompare">
                        <h5 id="h6" className="text-center"></h5>
                        <table>
                            <thead>
                                {list.length &&
                                    <tr>
                                        <th width="15%">&nbsp;</th>
                                        {list.map((x) => {
                                            return (
                                                <Fragment>
                                                    <th>{x.costingNumber} / {x.customerName} / {x.styleNumber}-{x.magnumStyleName}</th>
                                                </Fragment>
                                            )
                                        })}
                                    </tr>
                                }
                                <tr>
                                    <td colSpan="12">
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    list.length > 0 && Object.keys(list[0].fabric).map((y) => {
                                        return <tr>
                                            <td title="Fabric">{y}</td>
                                            {list.map((x) => {
                                                return <td>{x.fabric[y]}</td>
                                            })}
                                        </tr>
                                    })
                                }
                                {
                                    list.length > 0 && list[0].fabricTotalCost !== "0" && <tr>
                                        <th>Total</th>
                                        {list.map((x) => {
                                            return <th>{x.fabricTotalCost}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && Object.keys(list[0].trimPack).map((y) => {
                                        return <tr>
                                            <td title="TrimPack">{y}</td>
                                            {list.map((x) => {
                                                return <td>{x.trimPack[y]}</td>
                                            })}
                                        </tr>
                                    })
                                }
                                {
                                    list.length > 0 && Object.keys(list[0].trim).map((y) => {
                                        return <tr>
                                            <td title="Trim">{y}</td>
                                            {list.map((x) => {
                                                return <td>{x.trim[y]}</td>
                                            })}
                                        </tr>
                                    })
                                }
                                {
                                    list.length > 0 && list[0].trimTotalCost !== "0" && <tr>
                                        <th>Total</th>
                                        {list.map((x) => {
                                            return <th>{x.trimTotalCost}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && Object.keys(list[0].embellishment).map((y) => {
                                        return <tr>
                                            <td title="Embelishment">{y}</td>
                                            {list.map((x) => {
                                                return <td>{x.embellishment[y]}</td>
                                            })}
                                        </tr>
                                    })
                                }
                                {
                                    list.length > 0 && list[0].embelishmentTotalCost !== "0" && <tr>
                                        <th>Total</th>
                                        {list.map((x) => {
                                            return <th>{x.embelishmentTotalCost}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && Object.keys(list[0].embroidery).map((y) => {
                                        return <tr>
                                            <td title="Embroidery">{y}</td>
                                            {list.map((x) => {
                                                return <td>{x.embroidery[y]}</td>
                                            })}
                                        </tr>
                                    })
                                }
                                {
                                    list.length > 0 && list[0].embroideryTotalCost !== "0" && <tr>
                                        <th>Total</th>
                                        {list.map((x) => {
                                            return <th>{x.embroideryTotalCost}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && Object.keys(list[0].smockingSheering).map((y) => {
                                        return <tr>
                                            <td title="Smocking Sheering">{y}</td>
                                            {list.map((x) => {
                                                return <td>{x.smockingSheering[y]}</td>
                                            })}
                                        </tr>
                                    })
                                }
                                {
                                    list.length > 0 && list[0].smockingSheeringTotalCost !== "0" && <tr>
                                        <th>Total</th>
                                        {list.map((x) => {
                                            return <th>{x.smockingSheeringTotalCost}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && Object.keys(list[0].wash).map((y) => {
                                        return <tr>
                                            <td title="Wash">{y}</td>
                                            {list.map((x) => {
                                                return <td>{x.wash[y]}</td>
                                            })}
                                        </tr>
                                    })
                                }
                                {
                                    list.length > 0 && list[0].washTotalCost !== "0" && <tr>
                                        <th>Total</th>
                                        {list.map((x) => {
                                            return <th>{x.washTotalCost}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && Object.keys(list[0].others).map((y) => {
                                        return <tr>
                                            <td>{y}</td>
                                            {list.map((x) => {
                                                return <td>{x.others[y]}</td>
                                            })}
                                        </tr>
                                    })
                                }
                                {
                                    list.length > 0 && list[0].otherTotalCost !== "0" && <tr>
                                        <th>Total</th>
                                        {list.map((x) => {
                                            return <th>{x.otherTotalCost}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && list[0].fixedCharge !== "0" && <tr>
                                        <th>Fixed Charge</th>
                                        {list.map((x) => {
                                            return <th>{x.fixedCharge}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && list[0].cmt !== "0" && <tr>
                                        <th>CMT</th>
                                        {list.map((x) => {
                                            return <th>{x.cmt}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && list[0].cmt !== "0" && <tr>
                                        <th>Value Loss @</th>
                                        {list.map((x) => {
                                            return <th>{x.valueLoss}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    list.length > 0 && list[0].cmt !== "0" && <tr>
                                        <th>Contribution % to overheads</th>
                                        {list.map((x) => {
                                            return <th>{x.overHeads}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    <tr>
                                        <th>Total[INR]</th>
                                        {list.map((x) => {
                                            return <th>{x.costingTotal}</th>
                                        })}
                                    </tr>
                                }
                                {
                                    <tr>
                                        <th>System Total(Converted)</th>
                                        {list.map((x) => {
                                            return <th>{x.convertedTotal}</th>
                                        })}
                                    </tr>
                                }
                            </tbody>
                        </table>

                    </div>
                </div>
            </Fragment >
        )
    }
}

export default CostingComparison


// WEBPACK FOOTER //
// ./src/pages/CostingComparison/page.js